<script setup lang="ts">
/**
 * Raiz do app. Rota `standalone` (login e callback do PKCE) renderiza sozinha, sem o shell:
 * quem ainda não tem sessão não pode ver rail, bottom-nav nem contadores.
 */
import { computed } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import AppShell from '@/components/shell/AppShell.vue';

const route = useRoute();
const isStandalone = computed(() => route.meta.standalone === true);
</script>

<template>
  <AppShell v-if="!isStandalone" />
  <RouterView v-else />
</template>
